import { Logo } from "../../Components/Logo";
import React from "react";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

export default function DeleteAccount({ onBack }) {
    return (
        <Container component="main" maxWidth="lg">
            <CssBaseline />
            <Paper
                elevation={4}
                sx={{ p: 4, marginTop: 8, display: "flex", flexDirection: "column" }}
            >
                <Box
                    sx={{
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <Logo />

                    {/* Polityka usuwania konta */}
                    <Box sx={{ mt: 3, width: "100%" }}>
                        <Typography variant="h6" component="h2" sx={{ mb: 1 }}>
                            Polityka usuwania konta
                        </Typography>

                        <Typography variant="body2" component="div" sx={{ mb: 1 }}>
                            <strong>1. Wprowadzenie</strong>
                            <br />
                            Niniejsza Polityka określa zasady dotyczące usuwania konta użytkownika w aplikacji <strong>MICREE</strong>.
                            Dbamy o prywatność i bezpieczeństwo danych naszych użytkowników, dlatego proces usuwania konta został zaprojektowany
                            w sposób zapewniający potwierdzenie tożsamości osoby składającej wniosek.
                        </Typography>

                        <Typography variant="body2" component="div" sx={{ mb: 1 }}>
                            <strong>2. Sposób usunięcia konta</strong>
                            <br />
                            Użytkownik ma prawo w każdej chwili usunąć swoje konto z aplikacji. Aby tego dokonać, należy wysłać wiadomość e-mail z
                            prośbą o usunięcie konta na adres:
                            <br />
                            <code>info@micree.pl</code>
                            <br />
                            W treści wiadomości należy podać:
                            <ul>
                                <li>adres e-mail przypisany do konta w aplikacji,</li>
                                <li>jednoznaczną prośbę o usunięcie konta (np. „Proszę o usunięcie mojego konta w aplikacji [nazwa aplikacji]”),</li>
                            </ul>
                        </Typography>

                        <Typography variant="body2" component="div" sx={{ mb: 1 }}>
                            <strong>3. Weryfikacja i realizacja żądania</strong>
                            <br />
                            Po otrzymaniu wiadomości nasz zespół zweryfikuje, czy wiadomość została wysłana z adresu e-mail przypisanego do konta.
                            Po potwierdzeniu tożsamości użytkownika, konto zostanie trwale usunięte w ciągu <strong>14 dni roboczych</strong> od momentu
                            potwierdzenia żądania.
                        </Typography>

                        <Typography variant="body2" component="div" sx={{ mb: 1 }}>
                            <strong>4. Skutki usunięcia konta</strong>
                            <br />
                            Usunięcie konta jest <strong>nieodwracalne</strong>. Po usunięciu konta:
                            <ul>
                                <li>wszystkie dane użytkownika zostaną trwale usunięte lub zanonimizowane, zgodnie z obowiązującymi przepisami o ochronie danych osobowych (w tym RODO),</li>
                                <li>użytkownik utraci dostęp do wszystkich funkcji i treści powiązanych z kontem.</li>
                            </ul>
                        </Typography>

                        <Typography variant="body2" component="div" sx={{ mb: 1 }}>
                            <strong>5. Dane przechowywane po usunięciu konta</strong>
                            <br />
                            W niektórych przypadkach możemy przechowywać wybrane dane przez ograniczony czas, jeżeli jest to niezbędne do:
                            <ul>
                                <li>wypełnienia obowiązków prawnych,</li>
                                <li>rozpatrzenia roszczeń lub sporów,</li>
                                <li>zapewnienia zgodności z przepisami prawa.</li>
                            </ul>
                            Dane te są przechowywane wyłącznie w zakresie niezbędnym i przez okres określony przepisami prawa.
                        </Typography>

                        <Typography variant="body2" component="div" sx={{ mb: 1 }}>
                            <strong>6. Kontakt</strong>
                            <br />
                            W sprawach dotyczących usuwania konta lub ochrony danych osobowych prosimy o kontakt:
                            <br />
                            <code>info@micree.pl</code>
                        </Typography>

                    </Box>

                    <Button
                        type="button"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 5, mb: 2 }}
                        onClick={onBack || (() => (window.location.href = "/"))}
                    >
                        Powrót
                    </Button>
                </Box>
            </Paper>
        </Container>
    );
}
